<template>
  <div>
    <div v-if="video.preview" class="preview-box">
      <img class="preview-img" :src="video.preview | thumbVideo(150, 150)" />
      <div class="preview-footer">
        <div class="name v-ellipsis">{{ video.name }}</div>
        <i @click.stop="openWindow(video.preview)" class="operate-btn el-icon-zoom-in"></i>
        <i @click.stop="deleteFile" class="operate-btn el-icon-delete"></i>
      </div>
    </div>

    <div v-if="!video.preview" @click="chooseFile" class="upload-btn v-col v-center" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)">
      <i class="icon el-icon-plus"></i>
    </div>

    <upload-dialog v-if="isShowUploadDialog" :show.sync="isShowUploadDialog" type="video" @change="handleChange"></upload-dialog>
  </div>
</template>

<script>
import uploadDialog from './components/upload-dialog';

export default {
  components: { uploadDialog },

  props: ['id'],

  data() {
    return {
      loading: false,
      isShowUploadDialog: false,
      video: {},
    };
  },

  model: {
    prop: 'id',
    event: 'change',
  },

  created() {
    if (this.id) {
      this.getPreview();
    }
  },

  watch: {
    id: function(val) {
      if (typeof val == 'number' && val) {
        this.getPreview();
      }
    },
  },

  methods: {
    //根据id获取素材
    async getPreview() {
      this.loading = true;
      try {
        let res = await this.api.media.getPreview({ ids: [this.id] });
        this.video = res.data[this.id];
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    chooseFile() {
      this.isShowUploadDialog = true;
    },

    //删除
    deleteFile() {
      this.video = {};
      this.$emit('change', '');
    },

    handleChange(videos) {
      let { key, preview, name, id } = videos[0];
      let video = { key, preview, name, id };
      this.video = video;
      this.$emit('change', id);
    },

    openWindow(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 10px 0;
  width: 150px;
  height: 150px;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-box {
  position: relative;
  line-height: 1;
  width: 150px;

  .preview-img {
    display: block;
    width: 150px;
    height: 150px;
  }

  .preview-footer {
    display: flex;
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    align-items: center;
    transition: all 0.3s ease;
  }

  .preview-footer .name {
    flex: 1;
    font-size: 12px;
    padding: 0 10px;
    height: 25px;
  }

  .preview-footer .operate-btn {
    color: #fff;
    margin-right: 10px;
    cursor: pointer;
    line-height: 25px;
  }
}
</style>
